'use client';

import { LocationIcon } from '@/_assets/icon-components';
import { ISavedBranch } from '@/_store/types';
import { IBranch } from '@/_types';
import { Box, HStack, Stack, Text, VStack } from '@chakra-ui/react';
import React, { Dispatch } from 'react';

interface IProps {
  data: IBranch[];
  branchRefs?: any;
  selectedBranch: ISavedBranch | null;
  setSelectedBranch: Dispatch<IBranch | null>;
  onSelectBranch?: (val: IBranch | null) => void;
}

const Content = ({
  data,
  branchRefs,
  onSelectBranch,
  selectedBranch,
  setSelectedBranch,
}: IProps) => {
  return (
    <Stack
      mt={2}
      flex={1}
      gap={4}
      w={'full'}
      maxH={{ base: 'calc(100dvh - 326px)', lg: '290px' }}
      overflow={'auto'}
      scrollbar={'hidden'}
    >
      {data?.map((el) => {
        return (
          <VStack
            me={{ base: 0, lg: 2 }}
            key={el.id}
            ref={(elRef) => {
              if (elRef) {
                if (branchRefs?.current) {
                  branchRefs.current[el.id] = elRef;
                }
              }
            }}
            alignItems={'start'}
            border={'1px solid'}
            borderColor={selectedBranch?.id === el.id ? 'primary' : 'gray.300'}
            rounded={16}
            cursor={'pointer'}
            _hover={{
              border: '1px solid',
              borderColor: 'primary',
            }}
            color='text'
            gap={2}
            p={4}
            bg='background.card'
            onClick={() => {
              setSelectedBranch(el);
              onSelectBranch?.(el);
            }}
          >
            <HStack
              justifyContent={'space-between'}
              w={'full'}
              alignItems={'flex-start'}
            >
              <HStack color={'balck'} alignItems={'center'} gap={2} flex={1}>
                <Box
                  minW='24px'
                  h='24px'
                  display='flex'
                  alignItems='center'
                  justifyContent='center'
                >
                  <LocationIcon color='currentColor' />
                </Box>
                <Text fontWeight={500} fontSize={20} lineHeight={1.2}>
                  {el?.name}
                </Text>
              </HStack>
              <Box
                ml={2}
                flexShrink={0}
                fontSize={'sm'}
                fontWeight={500}
                color={'primary'}
              >
                <Text textAlign={'end'} whiteSpace='nowrap'>
                  с {el?.open_time} до {el?.close_time}
                </Text>
              </Box>
            </HStack>
            <Text fontSize={'sm'} color='gray.600' lineHeight={1.3} mt={-1}>
              {el.address}
            </Text>
          </VStack>
        );
      })}
    </Stack>
  );
};

export default Content;
